import { useMemo } from "react";
import { getLocalDateString } from "../util/formatDate";

export const useMergedSchedule = (appointments, doctorSchedule, selectedDoctor, selectedDate, setCounter) => {
    return useMemo(() => {
        if (!doctorSchedule) return [];
        const normalizedAppointments = appointments.map(a => ({
            ...a,
            time: a.time?.slice(0,5),
            availability: "reservado"
        }));
        const freeSlots = doctorSchedule.map(slot => ({
            time: slot,
            availability: "disponible",
            doctor: selectedDoctor,
            date: getLocalDateString(selectedDate),
        }));
        return [...normalizedAppointments, ...freeSlots].sort((a,b) => {
            if (!a.time && !b.time) return 0;
            if (!a.time) return 1;                 
            if (!b.time) return -1;                
            return a.time.localeCompare(b.time);       
        });
    }, [appointments, doctorSchedule, selectedDoctor, selectedDate]);
};